import { MobilfunkEntry } from '../model/mobilfunk';
import { DataFetcher } from './fetcher/DataFetcher';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface MobilfunkSearchParams extends AbstractSearchParams {
  countries?: string;
  duration?: string;
  radiation_source?: string;
  radiation_sleep?: string;
  symptom_disease?: string;
  distance_mast?: string;
  title?: string;
  tags?: string;
  report_from?: string;
  date?: string;
  license?: string;
  country?: string;
}

export class MobilfunkRepository extends RepositoryNocoDbBase<MobilfunkEntry, MobilfunkSearchParams> {
  protected readonly TABLE_NAME = 'mobilfunk';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'originally_published_at';

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS = [
    'country',
    'duration',
    'distance_mast',
    'symptom_disease',
    'radiation_sleep',
    'radiation_source'
  ];

  protected readonly SEARCH_FIELDS: (keyof MobilfunkEntry)[] = [
    'remark',
    'firstname_damaged',
    'symptom_disease',
    'radiation_source'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
